<app-nav></app-nav>
<section class="plan-leave">
  <div class="col">
    <div class="row">
      <div class="col">
        <span class="pending-approval-status"><i class="fa fa-square" aria-hidden="true"></i></span><span
          class="status-title">Pending Approval</span>
      </div>
      <div class="col">
        <span class="unpaid-leave-status"><i class="fa fa-square" aria-hidden="true"></i></span><span
          class="status-title">Unpaid Leave</span>
      </div>
    </div>
    <div class="row top-gap-xs">
      <div class="col">
        <span class="paid-leave-status"><i class="fa fa-square" aria-hidden="true"></i></span><span
          class="status-title">Paid Leave</span>
      </div>
      <div class="col">
        <span class="rejected-leave-status"><i class="fa fa-square" aria-hidden="true"></i></span><span
          class="status-title">Rejected Leave</span>
      </div>
    </div>
  </div>
  <div class="ui-g ui-fluid">
    <div class="col top-gap-sm plan-leave-calender">
      <p-calendar #calendar [(ngModel)]="value" [inline]="true" (onMonthChange)="onMonthChange()"
        selectionMode="multiple" (ngModelChange)="changedExtraHandler($event)" (onSelect)="onDateSelected($event)"
        [disabledDays]="[0]" ngDefaultControl>

        <ng-template pTemplate="date" let-date>
          <span id="{{date.year}}{{(date.month + 1 < 10 ? '0' + (date.month + 1) : date.month + 1)}}{{date.day}}" style="border-radius:50%">{{date.day}}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>
  <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
    <div class="col top-gap-md">
      <textarea name="comment" class="form-control" maxlength="5000" rows="3" id="comment" placeholder="Add Comment"
        [(ngModel)]="comment" required="required"></textarea>
    </div>
  </form>
  <div class="col">
    <div class="row top-gap-md">
      <div class="col">
        <button class="btn btn-common" (click)="backClicked()" data-toggle="modal">Cancel</button>
      </div>
      <div class="col">
        <button class="btn btn-common" (click)="submitLeaveAction()" data-toggle="modal">Submit</button>
      </div>
    </div>
  </div>
  <div class="modal fade" id="applyLeaveModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group text-center">
            <span [innerHtml]="successMessage"></span>
            <span [innerHtml]="errorMessage"></span>
          </div>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer text-center">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
        </div>

      </div>
    </div>
  </div>
  <div class="modal fade" id="ignoreSelection">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group text-center">
            <span class="errorMessage"></span>
          </div>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer text-center">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
        </div>

      </div>
    </div>
  </div>
</section>